import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import WorkplaceUserSelect, {
	WorkplaceUserSelectType,
} from './WorkplaceUserSelect';
import { SelectValue } from '../../../Select';

interface Props extends BaseFieldProps {
	workplaceId?: string;
	type: WorkplaceUserSelectType;
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	placeholder?: string;
}

const WorkplaceUserSelectField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<WorkplaceUserSelect
				workplaceId={props.workplaceId}
				type={props.type}
				onChange={props.onChange}
				value={props.value}
				placeholder={props.placeholder}
			/>
		</BaseField>
	);
};

export default WorkplaceUserSelectField;
